/****
 * LRR Versions
 * 1.1.0
 * 
 */
const versionApp = '1.0'
require('./bootstrap');

import { ref, createApp, h } from 'vue';
import { createInertiaApp, usePage } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { Inertia } from '@inertiajs/inertia';
// LRR
import { createPinia } from "pinia";
import { useStyleStore } from "@/stores/style.js";
import { darkModeKey, styleKey } from "@/config.js";
//import { useMainStore } from "@/stores/main.js";
import constanteApi from "@/conf-global.js";
//import VuePwaInstallPlugin from "vue-pwa-install";// udpate 230415
//import axios from "axios";
//import wysiwyg from "vue-wysiwyg";// <-- 230413
import helpers from './Common/helpers';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'UnensEdu';// LRR título sufijo

// LRR usar constanteApi
const constGlobal = ref({});

/* LRR no quiero usar el ref()
const constantes = ref({})
constantes.value = constantes
let url = '/constante/global';
const getConstantes = () => {
  axios.get(url).then(function (response) {
      //let constantes = {}
      var respuesta = response.data;
      constantes.value = respuesta.constantes;
      //console.log(constantes);
      //return constantes.value
      
    }).catch(function (error) {
        console.log(error);
  });
}
getConstantes()
//console.log(constantes);
*/

// Prueba axios de una linea
//const getData = () => axios.get(url).then(r => r.data.constantes).catch(e => console.log(e))
//getData()
//console.log(constantes);
//const constantes = getConstantes()
//let constantes = getData();

/* - LRR bakup Para crea constante global
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({ methods: { route } })
            .use(pinia)// LRR
            .mount(el);
    },
});
*/

const collaboratorProto = {
    right(module, action) {
        const parsed = this._parsedRights;
        return !!(parsed && parsed[module] && parsed[module][action]);
    }
};

function wrapCollaborator(obj) {
    if (obj._isWrappedCollaborator) return obj;

    let rawRights = obj.right || obj._enumerableRights;
    let parsedRights = {};
    if (typeof rawRights === 'string') {
        try {
            parsedRights = JSON.parse(rawRights);
        } catch (e) {
            parsedRights = {};
        }
    } else if (rawRights && typeof rawRights === 'object') {
        parsedRights = rawRights;
    }

    if ('right' in obj && typeof obj.right !== 'function') {
        Object.defineProperty(obj, '_enumerableRights', {
            value: rawRights,
            writable: true,
            enumerable: true,
            configurable: true
        });
        delete obj.right;
    }

    Object.defineProperty(obj, '_parsedRights', {
        value: parsedRights,
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.defineProperty(obj, '_isWrappedCollaborator', {
        value: true,
        writable: true,
        enumerable: false,
        configurable: true
    });

    Object.setPrototypeOf(obj, collaboratorProto);

    return obj;
}

function decorateCollaborator(obj, visited = new Set()) {
    if (!obj || typeof obj !== 'object') return obj;
    if (visited.has(obj)) return obj;
    visited.add(obj);

    if ('id_person' in obj && ('right' in obj || '_enumerableRights' in obj) && !obj._isWrappedCollaborator) {
        return wrapCollaborator(obj);
    }

    if (Array.isArray(obj)) {
        for (let i = 0; i < obj.length; i++) {
            obj[i] = decorateCollaborator(obj[i], visited);
        }
        return obj;
    }

    for (const key in obj) {
        if (obj.hasOwnProperty(key) && typeof obj[key] === 'object' && obj[key] !== null) {
            obj[key] = decorateCollaborator(obj[key], visited);
        }
    }
    return obj;
}

// Intercept Inertia page updates at the router source to decorate props before Vue reactive updates
let _inertiaPage = Inertia.page;
Object.defineProperty(Inertia, 'page', {
    get() {
        return _inertiaPage;
    },
    set(value) {
        if (value && value.props) {
            decorateCollaborator(value.props);
        }
        _inertiaPage = value;
    },
    configurable: true,
    enumerable: true
});

function checkUserRight(pageProps, module, perms = null, subperms = null) {
    if (!pageProps || !pageProps.auth) return false;
    const user = pageProps.auth.user;
    const rights = pageProps.auth.rights;

    // Superadmin: user id 1 o 2
    if (user && (user.id === 1 || user.id === 2 || rights?.is_superadmin)) {
        return true;
    }

    if (!rights) return false;

    // Notación de puntos (ej. "global.classroom" o "finanzas.formacion.read")
    if (perms === null && typeof module === 'string' && module.includes('.')) {
        const parts = module.split('.');
        module = parts[0];
        perms = parts[1];
        subperms = parts[2] || null;
    }

    const mod = (module || '').toLowerCase();
    const perm = (perms || '').toLowerCase();
    const sub = subperms ? subperms.toLowerCase() : null;

    if (rights.map && rights.map[mod]) {
        if (!perm) return true;
        const modVal = rights.map[mod];
        if (typeof modVal === 'boolean') return modVal;
        if (modVal[perm] !== undefined) {
            if (sub) {
                return !!(typeof modVal[perm] === 'object' && modVal[perm][sub]);
            }
            return !!modVal[perm];
        }
    }

    if (rights.slugs && Array.isArray(rights.slugs)) {
        const slug1 = sub ? `${mod}.${perm}.${sub}` : `${mod}.${perm}`;
        const slug2 = `${mod}.${perm}.read`;
        return rights.slugs.includes(slug1) || (!sub && rights.slugs.includes(slug2));
    }

    return false;
}

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) => require(`./Pages/${name}.vue`),
  setup({ el, app, props, plugin }) {
       decorateCollaborator(props);
       constGlobal.value = props.initialPage.props.confGlobal || {};

       const hasRightHelper = function(module, perms, subperms) {
           const pageProps = this?.$page?.props || props?.initialPage?.props;
           return checkUserRight(pageProps, module, perms, subperms);
       };

       const myApp = createApp({ render: () => h(app, props),
            provide: {
              helpers: helpers,
              hasRight: (mod, perm, sub) => checkUserRight(props?.initialPage?.props, mod, perm, sub)
          } })
          .use(plugin)
          .mixin({
              methods: {
                  route,
                  hasRight: hasRightHelper,
                  $hasRight: hasRightHelper
              }
          })
          .use(pinia)// LRR
          //.use(VuePwaInstallPlugin);// update 230415
          //.use(wysiwyg)// LRR 230413
          // LRR crear variable global
          //myApp.config.globalProperties.$confglobal = 'Hola';
          myApp.config.globalProperties.versionApp = versionApp
          myApp.config.globalProperties.confGlobal = constGlobal
          myApp.config.globalProperties.hasRight = hasRightHelper
          myApp.config.globalProperties.$hasRight = hasRightHelper
          myApp.mount(el);

          // Remover preloader inicial de forma suave
          const loader = document.getElementById('unens-app-loader');
          if (loader) {
              loader.style.opacity = '0';
              loader.style.visibility = 'hidden';
              setTimeout(() => {
                  if (loader.parentNode) loader.parentNode.removeChild(loader);
              }, 350);
          }

          return myApp;
  },
});

InertiaProgress.init({ color: '#e11d48', showSpinner: true });

// LRR
/* Init Pinia */
const pinia = createPinia();

/* Create Vue app */
//createApp(App).use(router).use(pinia).mount("#app");

/* Init Pinia stores */
//const mainStore = useMainStore(pinia);
const styleStore = useStyleStore(pinia);

/* App style */
styleStore.setStyle(localStorage[styleKey] ?? "basic");

// LRR establecer modo oscuro como false
//styleStore.setDarkMode(localStorage[darkModeKey] ?? "0");// <- iniclaiiza creo

/* Dark mode */
if (
    (!localStorage[darkModeKey] &&
      window.matchMedia("(prefers-color-scheme: dark)").matches) ||
    localStorage[darkModeKey] === "1"
  ) {
    styleStore.setDarkMode(true);
  }
// Fin LRR

/**
 * PWA
 * 
 */
/* if ( navigator.serviceWorker ) {
  navigator.serviceWorker.register('./sw.js').then(() => { console.log('SW Registered'); });
}

let deferredPrompt;
// LRR const addBtn = document.querySelector('.install-button');// <-- Antes usaba la clase
const addBtn = document.querySelector('#install-button');
addBtn.style.display = 'none';
//const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'UnensEdu';// LRR título sufijo

window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    // Update UI to notify the user they can add to home screen
    addBtn.style.display = 'block';

    addBtn.addEventListener('click', () => {
        // hide our user interface that shows our A2HS button
        addBtn.style.display = 'none';

        // Show the prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
        } else {
            console.log('User dismissed the A2HS prompt');
        }
        deferredPrompt = null;
        });
    });
}); */